import { PortfolioCentralRateGroupAddParameters } from '@mews-commander/data-access';

export type GeneralDetailsMetaFormValues = Pick<
    PortfolioCentralRateGroupAddParameters,
    'name' | 'shortName' | 'ordering' | 'description' | 'rateGroupKey'
>;

export enum FIELD_NAMES {
    IS_CENTRAL = 'isCentral',
    SERVICE_KEY = 'serviceKey',
    NAME = 'name',
    SHORT_NAME = 'shortName',
    DESCRIPTION = 'description',
    ORDERING = 'ordering',
    RATE_GROUP_KEY = 'rateGroupKey',
    SETTLEMENT_MAX_TIME = 'settlementMaximumTimeUnits',
    SETTLEMENT_EXTENT = 'settlementExtent',
    SETTLEMENT_OPTIONS = 'options',
    SETTLEMENT_CURRENCY = 'settlementCurrency',
    SETTLEMENT_ACTION = 'action',
    SETTLEMENT_TYPE = 'type',
    SETTLEMENT_TRIGGER = 'trigger',
    SETTLEMENT_OFFSET_DAYS = 'settlementOffsetDays',
    SETTLEMENT_OFFSET_HOURS = 'settlementOffsetHours',
    SETTLEMENT_OFFSET_MINUTES = 'settlementOffsetMinutes',
    SETTLEMENT_VALUE = 'settlementValue',
    SETTLEMENT_VALUE_AMOUNT = 'settlementValueAmount',
    CANCELLATION_APPLICABILITY = 'applicability',
    CANCELLATION_APPLICABILITY_OFFSET_DAYS = 'cancellationApplicabilityOffsetDays',
    CANCELLATION_APPLICABILITY_OFFSET_HOURS = 'cancellationApplicabilityOffsetHours',
    CANCELLATION_APPLICABILITY_OFFSET_MINUTES = 'cancellationApplicabilityOffsetMinutes',
    CANCELLATION_MAX_TIME = 'feeMaximumTimeUnits',
    CANCELLATION_CURRENCY = 'cancellationCurrency',
    CANCELLATION_RELATIVE_FEE = 'relativeFee',
    CANCELLATION_ABSOLUTE_FEE = 'absoluteFee',
}
